import { CircularProgress, Grid, Typography } from "@mui/material";
import moment from "moment";
import { useGetAllMeetingsQuery } from "../../../redux/Hire/candidateMeetingApi";
import { CandidateDetails } from "../../../redux/Hire/jobRequestApi";

type Props = {
  candidate?: CandidateDetails;
  jobId?: string;
};

const ClientInterview = ({ candidate, jobId }: Props) => {
  const { data, isFetching } = useGetAllMeetingsQuery({
    candidateId: candidate?.id.toString() || "",
    candidateStage: candidate?.stage || "",
  });

  return (
    <Grid container gap={2} alignItems="center">
      <Grid item>
        {isFetching && <CircularProgress size={20} />}
        {!isFetching && data?.data.length === 0 && (
          <Typography fontSize={"14px"} color={"#0F1829"}>
            Candidate has not selected a time slot yet
          </Typography>
        )}
        {!isFetching && (data?.data.length || 0) > 0 && (
          <>
            <Typography fontSize={"14px"} color={"#0F1829"}>
              Interview scheduled on
            </Typography>
            <Typography fontSize={"14px"} color={"#0F1829"} fontWeight={700}>
              {moment(data?.data[0].meetingStartedOn).format(
                "Do MMMM YYYY, hh:mm a",
              )}{" "}
              <Typography
                fontWeight={"400"}
                fontSize={"14px"}
                component={"span"}
              >
                with
              </Typography>{" "}
              {data?.data[0].interviewerName}
            </Typography>
          </>
        )}
      </Grid>
    </Grid>
  );
};

export default ClientInterview;
